/** Curated emoji set with Spanish keywords for search (no external dependency). */
export interface EmojiEntry {
  char: string;
  keywords: string;
}

const group = (entries: [string, string][]): EmojiEntry[] =>
  entries.map(([char, keywords]) => ({ char, keywords }));

export const emojiCategories: { id: string; label: string; emojis: EmojiEntry[] }[] = [
  {
    id: 'caras',
    label: 'Caras',
    emojis: group([
      ['😀', 'sonrisa feliz'],
      ['😃', 'sonrisa alegre'],
      ['😄', 'risa feliz'],
      ['😁', 'sonrisa dientes'],
      ['😆', 'risa carcajada'],
      ['😅', 'risa nervios sudor'],
      ['😂', 'lagrimas risa'],
      ['🤣', 'revolcarse risa'],
      ['🙂', 'sonrisa leve'],
      ['😉', 'guiño'],
      ['😊', 'sonrisa sonrojo'],
      ['😇', 'angel inocente'],
      ['🥰', 'amor corazones'],
      ['😍', 'enamorado ojos corazon'],
      ['🤩', 'estrellas asombro'],
      ['😘', 'beso'],
      ['😋', 'rico delicioso'],
      ['😜', 'lengua guiño broma'],
      ['🤪', 'loco'],
      ['🤗', 'abrazo'],
      ['🤔', 'pensar duda'],
      ['🤨', 'ceja sospecha'],
      ['😐', 'neutral serio'],
      ['😶', 'sin palabras'],
      ['🙄', 'ojos en blanco'],
      ['😏', 'picaro'],
      ['😬', 'mueca incomodo'],
      ['😌', 'aliviado'],
      ['😴', 'dormir sueño'],
      ['🤒', 'enfermo'],
      ['🤯', 'mente explota alucinar'],
      ['🥳', 'fiesta celebrar'],
      ['😎', 'gafas guay'],
      ['🤓', 'empollon nerd'],
      ['😕', 'confuso'],
      ['😟', 'preocupado'],
      ['😮', 'sorpresa'],
      ['😲', 'asombro'],
      ['🥺', 'suplica porfa'],
      ['😢', 'llorar triste'],
      ['😭', 'llanto'],
      ['😱', 'miedo grito'],
      ['😤', 'resoplar enfado'],
      ['😡', 'enfadado rabia'],
      ['🤬', 'insultos'],
      ['💀', 'calavera muerto risa'],
      ['🤡', 'payaso'],
      ['👻', 'fantasma'],
    ]),
  },
  {
    id: 'gestos',
    label: 'Gestos',
    emojis: group([
      ['👍', 'bien ok vale pulgar arriba si'],
      ['👎', 'mal pulgar abajo no'],
      ['👌', 'ok perfecto'],
      ['✌️', 'paz victoria'],
      ['🤞', 'suerte dedos cruzados'],
      ['🤝', 'trato acuerdo apreton'],
      ['👏', 'aplausos bravo'],
      ['🙌', 'celebrar manos arriba'],
      ['🙏', 'gracias por favor rezar'],
      ['💪', 'fuerza musculo'],
      ['👋', 'hola adios saludo'],
      ['🤙', 'llamame'],
      ['👀', 'ojos mirar'],
      ['🫡', 'saludo militar entendido'],
      ['🤷', 'no se encoger hombros'],
      ['🤦', 'facepalm'],
      ['🙋', 'mano levantada pregunta'],
      ['🙆', 'vale ok'],
      ['👉', 'señalar derecha'],
      ['👇', 'abajo señalar'],
      ['☝️', 'uno arriba atencion'],
      ['✍️', 'escribir'],
      ['🫶', 'corazon manos'],
      ['🖖', 'vulcano'],
    ]),
  },
  {
    id: 'simbolos',
    label: 'Símbolos',
    emojis: group([
      ['❤️', 'corazon amor rojo'],
      ['🧡', 'corazon naranja'],
      ['💛', 'corazon amarillo'],
      ['💚', 'corazon verde'],
      ['💙', 'corazon azul'],
      ['💜', 'corazon morado'],
      ['🖤', 'corazon negro'],
      ['💔', 'corazon roto'],
      ['🔥', 'fuego genial'],
      ['✨', 'brillo magia'],
      ['⭐', 'estrella'],
      ['🎉', 'fiesta confeti celebrar'],
      ['🎊', 'confeti'],
      ['💯', 'cien perfecto'],
      ['✅', 'hecho ok check listo'],
      ['☑️', 'marcado'],
      ['❌', 'error no cruz'],
      ['⚠️', 'aviso atencion cuidado'],
      ['❗', 'importante exclamacion'],
      ['❓', 'pregunta duda'],
      ['💡', 'idea bombilla'],
      ['🚀', 'cohete lanzamiento rapido'],
      ['⚡', 'rayo rapido energia'],
      ['🎯', 'objetivo diana'],
      ['📌', 'chincheta fijar'],
      ['🔗', 'enlace link'],
      ['🔒', 'candado privado'],
      ['🆕', 'nuevo'],
      ['⏰', 'alarma hora'],
      ['⏳', 'esperando tiempo'],
      ['📅', 'calendario fecha'],
      ['🏁', 'meta final'],
    ]),
  },
  {
    id: 'trabajo',
    label: 'Trabajo',
    emojis: group([
      ['💻', 'portatil ordenador'],
      ['🖥️', 'ordenador pantalla'],
      ['📱', 'movil telefono'],
      ['⌨️', 'teclado'],
      ['📊', 'grafico datos'],
      ['📈', 'subida crecimiento'],
      ['📉', 'bajada'],
      ['📝', 'nota escribir'],
      ['📎', 'clip adjunto'],
      ['📁', 'carpeta'],
      ['📄', 'documento'],
      ['📦', 'paquete envio'],
      ['🐛', 'bug error fallo'],
      ['🔧', 'herramienta arreglar'],
      ['⚙️', 'ajustes configuracion'],
      ['🧪', 'prueba test'],
      ['🔍', 'buscar lupa'],
      ['💬', 'mensaje chat'],
      ['📣', 'anuncio megafono'],
      ['📞', 'llamada telefono'],
      ['🎥', 'video camara'],
      ['🎨', 'diseño arte'],
      ['☕', 'cafe'],
      ['🍕', 'pizza comida'],
      ['🍻', 'cervezas brindis'],
      ['🏆', 'trofeo ganar'],
      ['💰', 'dinero'],
      ['🧠', 'cerebro idea'],
    ]),
  },
];

export const allEmojis = emojiCategories.flatMap((c) => c.emojis);

export function searchEmojis(query: string): EmojiEntry[] {
  const q = query.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  if (!q) return allEmojis;
  return allEmojis.filter((e) => e.keywords.includes(q));
}
